module.exports = __webpack_public_path__ + "img/naked-insurance-banner-square-2.4b062c06.jpg";